import AnalyticsV2Page from './AnalyticsV2Page';

/** Candidate analytics — v2 layout (matches skipscreen-rebuild). */
const Analytics = AnalyticsV2Page;

export default Analytics;
